import { BOLD_WRAPPER_REGEX } from '@apps/utils/constants'

// Footnote markers authored either as <sup> tags or unicode superscripts,
// including the "⁴,⁵" comma-separated runs.
const FEATURE_SUPERSCRIPT = '<sup>[\\s\\S]*?<\\/sup>|[⁰¹²³⁴⁵⁶⁷⁸⁹]'
export const FEATURE_SUPERSCRIPT_REGEX = new RegExp(
  `(?:${FEATURE_SUPERSCRIPT})(?:\\s*,\\s*(?:${FEATURE_SUPERSCRIPT}))*`,
  'g'
)

const MARKDOWN_BOLD_REGEX = /\*{1,2}([\s\S]+?)\*{1,2}/g

/**
 * Flattens a plan feature string for surfaces that can only render plain text.
 * Plan features carry emphasis markup — `{{text}}` wrappers, `**text**`
 * markdown — plus footnote superscripts, all of which leak verbatim when the
 * string is handed to a component that renders it as-is.
 */
export const toPlainFeatureText = (value) => {
  if (typeof value !== 'string') return ''

  return value
    .replace(FEATURE_SUPERSCRIPT_REGEX, '')
    .replace(BOLD_WRAPPER_REGEX, (_match, wrappedText) => wrappedText)
    .replace(MARKDOWN_BOLD_REGEX, '$1')
    .replace(/\s+/g, ' ')
    .trim()
}

export default toPlainFeatureText
